var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_755_15375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_15375)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#93370D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_755_15375)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8525,
    cy: 15.0595,
    rx: 24.1463,
    ry: 23.7024,
    fill: "#FDB022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_755_15375)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6326,
    cy: 11.7855,
    rx: 14.7561,
    ry: 14.4048,
    fill: "#FEC84B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_755_15375)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.2504,
    cy: 3.73998,
    rx: 6.2504,
    ry: 3.73998,
    transform: "matrix(0.981993 -0.188915 0.196258 0.980552 20.1208 37.7184)",
    fill: "#F79009"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 10.76C21.8533 10.76 22.96 10.9467 23.92 11.32C24.9067 11.6933 25.68 12.2267 26.24 12.92C26.8 13.5867 27.08 14.4 27.08 15.36C27.08 16.3733 26.76 17.32 26.12 18.2C25.48 19.08 24.6 19.84 23.48 20.48C22.3867 21.12 21.12 21.6133 19.68 21.96C21.3067 21.9333 22.7867 22.1467 24.12 22.6C25.4533 23.0267 26.52 23.7067 27.32 24.64C28.12 25.5467 28.52 26.6933 28.52 28.08C28.52 29.3067 28.2 30.44 27.56 31.48C26.92 32.4933 26.0533 33.4 24.96 34.2C23.8933 35.0267 22.6533 35.72 21.24 36.28C19.8267 36.8667 18.3467 37.3067 16.8 37.6C15.28 37.8933 13.7733 38.04 12.28 38.04V37.28C13.56 37.2267 14.84 37 16.12 36.6C17.4267 36.2 18.6133 35.6133 19.68 34.84C20.7733 34.0667 21.64 33.12 22.28 32C22.9467 30.8533 23.28 29.5467 23.28 28.08C23.28 26.5067 22.9067 25.2133 22.16 24.2C21.4133 23.1867 20.3867 22.6267 19.08 22.52C18.68 22.68 18.3067 22.8267 17.96 22.96C17.64 23.0933 17.3333 23.16 17.04 23.16C16.8267 23.16 16.6533 23.12 16.52 23.04C16.4133 22.9333 16.36 22.7733 16.36 22.56C16.36 22.2933 16.48 22.0933 16.72 21.96C16.96 21.8267 17.24 21.76 17.56 21.76C17.7733 21.76 17.9867 21.7733 18.2 21.8C18.44 21.8267 18.6933 21.8533 18.96 21.88C20.08 21.08 20.8667 20.2133 21.32 19.28C21.8 18.32 22.04 17.36 22.04 16.4C22.04 15.1733 21.72 14.28 21.08 13.72C20.44 13.1333 19.5867 12.84 18.52 12.84C17.4533 12.84 16.4533 13.12 15.52 13.68C14.6133 14.2133 13.8533 15.0267 13.24 16.12L12.56 15.76C13.0133 14.88 13.5733 14.0667 14.24 13.32C14.9333 12.5467 15.8 11.9333 16.84 11.48C17.88 11 19.1333 10.76 20.6 10.76Z",
    fill: "#7A2E0E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_755_15375",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.406349,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_755_15375"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.407843 0 0 0 0 0.0117647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_755_15375"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_755_15375",
    x: -20.2575,
    y: -24.6066,
    width: 80.2202,
    height: 79.3322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15375"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_755_15375",
    x: -14.0873,
    y: -18.583,
    width: 61.4396,
    height: 60.7369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15375"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_755_15375",
    x: 13.148,
    y: 28.6886,
    width: 27.6895,
    height: 23.0326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83129,
    result: "effect1_foregroundBlur_755_15375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_15375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber4);
export default __webpack_public_path__ + "static/media/number4.aefd1d3e58384d76c4156e469c27d3f6.svg";
export { ForwardRef as ReactComponent };